import OrderHistory from './OrderHistory.component';

export default OrderHistory;
